
import { usePreviewData } from "@/hooks/preview/usePreviewData";
import PreviewHeader from "@/components/preview/PreviewHeader";
import RequestSummaryCard from "@/components/preview/RequestSummaryCard";
import AIResponsePreview from "@/components/preview/AIResponsePreview";
import SignUpBenefitsCard from "@/components/preview/SignUpBenefitsCard";

const Preview = () => {
  const { demoRequest, handleSignUpAndSave } = usePreviewData();

  if (!demoRequest) {
    return (
      <div className="container py-8 flex flex-col items-center justify-center min-h-[60vh]">
        <div className="animate-spin h-8 w-8 border-4 border-primary border-t-transparent rounded-full mb-4"></div>
        <p className="text-muted-foreground">Loading preview...</p>
      </div>
    );
  }

  return (
    <div className="container py-8 max-w-2xl">
      <PreviewHeader />
      
      <div className="mb-6">
        <RequestSummaryCard 
          merchant={demoRequest.merchant}
          amount={demoRequest.amount}
          orderNumber={demoRequest.order_number}
          tone={demoRequest.tone}
          issue={demoRequest.issue}
        />
        
        <AIResponsePreview 
          responseContent={demoRequest.aiResponse}
          tone={demoRequest.tone}
          merchant={demoRequest.merchant}
        />
      </div>
      
      <SignUpBenefitsCard onSignUp={handleSignUpAndSave} />
    </div>
  );
};

export default Preview;
